import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuInformationBox} from '@Components/contextual-menu/components/contextual-menu-information-box';
import {InformationBoxType} from '@Components/contextual-menu/components/information-box';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {openDownloadModal} from '@Components/poster-editor/library/poster-editor-open-modals';
import {updatePublishDropDownState} from '@Components/poster-editor/poster-editor-reducer';
import {setOrderDetails, setShowLoader, webpageEmbedFlow, webpagePublishFlow} from '@Panels/poster-publishing-options-panel/poster-publishing-options-slice';
import styles from './information-link-option.module.scss';
import {useAppSelector} from '@/hooks';
import {getDefaultOrderDetails} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';

export function InformationLinkOption(): ReactElement<any> {
  const isVideo = useAppSelector((state) => {
    return state.posterEditor.isVideo;
  });

  const onDownloadAsPDF = (): void => {
    openDownloadModal();
  };

  const onPublishAsWebpage = (e: React.MouseEvent<Element, MouseEvent>): void => {
    e.stopPropagation();
    void window?.posterEditor?.whiteboard?.savePoster?.save().then(() => {
      window.PMW.redux.store.dispatch(webpagePublishFlow());
      window.PMW.redux.store.dispatch(setShowLoader(false));
      window.PMW.redux.store.dispatch(updatePublishDropDownState(true));
    });
  };

  const openPublishAsEmbeddedLink = (e: React.MouseEvent<Element, MouseEvent>): void => {
    e.stopPropagation();
    void window?.posterEditor?.whiteboard?.savePoster?.save().then(() => {
      window.PMW.redux.store.dispatch(webpageEmbedFlow());
      window.PMW.redux.store.dispatch(setOrderDetails(getDefaultOrderDetails()));
      window.PMW.redux.store.dispatch(updatePublishDropDownState(true));
    });
  };

  return (
    <ContextualMenuInformationBox id="information-link-option" type={InformationBoxType.NEUTRAL3}>
      <div>
        <Text className="content-sub-text" size={TextSize.XSMALL} val={window.i18next.t('pmwjs_interactivity_information_text')} />
        <ul className="spacing-m-t-3 spacing-m-b-0 spacing-m-l-0 spacing-m-r-0">
          {isVideo ? null : (
            <li className={`${styles.textRow} spacing-p-b-0 spacing-m-t-1 spacing-m-b-1 flexbox flex-items-center`}>
              <Icon icon="icon-check" size={IconSize.SIZE_ICON_16} className="content-disabled spacing-m-r-2" />
              <Text
                onClick={(): void => {
                  onDownloadAsPDF();
                }}
                val={window.i18next.t('pmwjs_download_as_pdf')}
                dangerouslySetInnerHTML
                className="content-link"
                size={TextSize.XSMALL}
              />
            </li>
          )}
          <li className={`${styles.textRow} spacing-p-b-0 spacing-m-t-1 spacing-m-b-1 flexbox flex-items-center`}>
            <Icon icon="icon-check" size={IconSize.SIZE_ICON_16} className="content-disabled spacing-m-r-2" />
            <Text
              onClick={(e): void => {
                onPublishAsWebpage(e);
              }}
              val={window.i18next.t('pmwjs_publish_webpage_2')}
              className="content-link"
              size={TextSize.XSMALL}
            />
          </li>
          <li className={`${styles.textRow} spacing-p-b-0 spacing-m-t-1 spacing-m-b-1 flexbox flex-items-center`}>
            <Icon icon="icon-check" size={IconSize.SIZE_ICON_16} className="content-disabled spacing-m-r-2" />
            <Text
              onClick={(e): void => {
                openPublishAsEmbeddedLink(e);
              }}
              val={window.i18next.t('pmwjs_publish_embedded_link')}
              className="content-link"
              size={TextSize.XSMALL}
            />
          </li>
        </ul>
      </div>
    </ContextualMenuInformationBox>
  );
}
